export const SESSION_CREATE = 'SESSION_CREATE';
export const SESSION_RESET = 'SESSION_RESET';
